module.exports = __webpack_public_path__ + "img/20.41667e52.jpg";